import type { Key } from "react";
import type {
  ICreateMode,
  IChangingMode,
  IOfferFieldName,
  IOfferFieldNameRule,
} from "../../../../../lib/types";
import { OFFER_STATUSES, OFFER_TYPES } from "../../../../../store/slices/offering/const";

const { PREPARE, SUSPENDED, ACTIVE, ARCHIVE } = OFFER_STATUSES;

// Template
// create: {
//   [PREPARE]: ,
//   [SUSPENDED]: ,
//   [ACTIVE]: ,
//   [ARCHIVE]: ,
// },

// Обязательность полей к заполенению по схеме: имя поля => режим измененения => статус предложения => правило доступности
export const isFieldRequired = (params: {
  fieldName: IOfferFieldName;
  viewMode: ICreateMode | IChangingMode;
  offeringStatusId: number;
  options?: { [key: Key]: any };
}): boolean => {
  const { fieldName, viewMode, offeringStatusId, options } = params;
  const fieldNameRules: IOfferFieldNameRule = {
    extName: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    name: {
      create: {},
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
      },
    },
    periodAlignmentId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    tariffModelId: {
      create: {
        [PREPARE]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    offeringStatusId: {},
    isStandalone: {},
    prolongTypeId: {
      create: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    lifespanPeriodId: {
      create: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      edit: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    lifespanPeriodQty: {},
    offeringTypeId: {},
    agreementId: {
      add: {
        [PREPARE]:
          options?.addVersionStatusId === OFFER_STATUSES.ACTIVE &&
          options?.offeringTypeId === OFFER_TYPES.PERSONAL,
      },
    },
    fromDate: {
      create: {
        [PREPARE]: true,
      },
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    toDate: {
      close: {
        [PREPARE]: true,
        [SUSPENDED]: true,
        [ACTIVE]: true,
        [ARCHIVE]: true,
      },
    },
    bundleTypeId: {
      create: {},
    },
  };
  if (fieldName === "name") {
    console.log({ params });
    console.log(Boolean(fieldNameRules[fieldName]?.[viewMode]?.[offeringStatusId]));
  }

  return Boolean(fieldNameRules[fieldName]?.[viewMode]?.[offeringStatusId]);
};
